import { createMuiTheme } from "@material-ui/core"

export const MainColor = createMuiTheme({
	palette: {
		primary: {
			main: '#113047',
			dark: '#39617F',
			contrastText: '#FFFFFF',
		},
	},
})